var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EqsDataTable',_vm._b({scopedSlots:_vm._u([{key:"item.operation_date",fn:function({ item }){return [_c('td',{attrs:{"el-class":`date`}},[_vm._v(" "+_vm._s(_vm.formatDate(item.operation_date))+" ")])]}},{key:"item.operation_type",fn:function({ value }){return [_c('EqsChip',{attrs:{"color":_vm.$color.colorFromHash(value)}},[_vm._v(" "+_vm._s(_vm.payment_types[value] ? _vm.payment_types[value].txt : value)+" ")])]}},{key:"item.value",fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.displayAmount(item))+" ")]}}])},'EqsDataTable',{
        itemKey: 'id',
        items: _vm.assets,
        headers: _vm.headers,
        column: false
    },false))
}
var staticRenderFns = []

export { render, staticRenderFns }